export default "__VITE_ASSET__74ZyqCS0__"